export default "__VITE_ASSET__BckBF13Q__"